// extracted by mini-css-extract-plugin
export default {"StrollerDetailRating":"xh_a bhg_a bhg_x","StrollerDetailRating__muted":"xh_b bhg_fm"};